/**
 * created by tian ruo jun
 treeModule
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Empty, Icon, Input, Tree, Tooltip} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from "../../../utils";

const {Search} = Input;
const {TreeNode} = Tree;

export default class TreeModule extends Component {
    static defaultProps = {
        height: 630,
        width: 720,
        nodeWidth:190,
        nodeTextWidth:160,
        showRight: true,
        showLeftSearch: true,
        showRightSearch: true,
        treeData:[],
        onExpand:()=>{},
        onCheck:()=>{},
        showRemoveAll:true,
        onRemoveAll:()=>{},
        onTreeSelect:()=>{},
    };
    static propTypes = {
        height: PropTypes.number,
        width: PropTypes.number,
        showRight: PropTypes.bool,
        showLeftSearch: PropTypes.bool,
        showRightSearch: PropTypes.bool,
        column:PropTypes.object,
        treeData:PropTypes.array.isRequired,
        selectList:PropTypes.array.isRequired,
        nodeWidth:PropTypes.number,
        nodeTextWidth:PropTypes.number,
        onExpand:PropTypes.func,
        onCheck:PropTypes.func,
        onRemoveAll:PropTypes.func,
        showRemoveAll:PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        if(this.props.expandedKeys && this.props.expandedKeys.length>0) {
            this.setState({})
        }
    }

    render() {
        let {height, width, showRight} = this.props;
        return (
            <div className={'TreeModule'} style={{display: 'flex', height: height, width: width, background: '#FFF'}}>
                {this.renderLeft()}
                {showRight ? this.renderRight() : null}
                <style>
                    {`
                        .TreeModule .ant-input {
                            background: #f5f8fc;
                        }
                    `}
                </style>
            </div>
        )
    }

    renderLeft = () => {
        const {showLeftSearch} = this.props;
        return (
            <div style={{flex: 1, border: '1px solid #d9d9d9'}}>
                {showLeftSearch ? this.renderLeftSearch() : null}
                {this.renderLeftTree()}
            </div>
        )
    };

    renderRight = () => {
        const {showRightSearch, onSelect, showRemoveAll, onRemoveAll,color} = this.props;
        return (
            <>
                <div style={{width: 55, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <div style={{width:' 24px',
                        height: '24px',
                        background: color,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: 'white',
                        cursor:"pointer",
                        borderRadius: '2px'}}  onClick={() => {
                        onSelect()
                    }}>
                        <Icon type="right"  />
                    </div>
                    {/*<Icon type="double-right" onClick={() => {*/}
                    {/*    onSelect()*/}
                    {/*}}/>*/}
                </div>
                <div style={{flex: 1, border: '1px solid #d9d9d9',position: "relative"}}>
                    {showRightSearch ? this.renderRightSearch() : null}
                    {showRemoveAll ? (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                            <div></div>
                            <Button type="link" onClick={() => {
                                onRemoveAll()
                            }}>移除全部</Button>
                        </div>
                    ) : null}
                    {this.renderRightList()}
                </div>
            </>
        )
    }

    renderLeftSearch = () => {
        const {onSearchTree}=this.props;
        return (
            <div style={{padding: '9px 17px', borderBottom: '1px solid #f0f0f0'}}>
                <Search
                    placeholder={'请输入关键字'}
                    allowClear={true}
                    onSearch={(val) => {
                        console.log(val,'val')
                        onSearchTree(val)
                    }}/>
            </div>
        )
    }

    renderRightSearch = () => {
        const {onSearchSelect}=this.props;
        return (
            <div style={{padding: '9px 17px', borderBottom: '1px solid #f0f0f0'}}>
                <Search
                    placeholder={'请输入关键字'}
                    allowClear={true}
                    onSearch={(val) => {
                        onSearchSelect(val)
                    }}/>
            </div>
        )
    };

    renderRightList = () => {
        const {selectList, height, onRemove} = this.props;
        let name = [];
        let selectListLength = selectList && selectList.length && selectList.filter(item => !item.hide) && selectList.filter(item => !item.hide).length || 0
        selectList && selectList.length && selectList.forEach((item, index) => {
            name = [];
            if (item.deptList && item.deptList.length) {
                let key = item.key && item.key.split('-').at(-2);
                if (key) {
                    item.deptList.forEach((i => {
                        if (i.id === key) {
                            name.push(i.name)
                        }
                    }))
                } else {
                    item.key = item.deptList[0].id + '-' + item.id;
                    name.push(item.deptList[0].name)
                }
            }
            item.deptName = name
        });
        let newSelectList = selectList;
        try {
            newSelectList = JSON.parse(JSON.stringify(selectList));
            newSelectList = newSelectList ? newSelectList.sort((a,b)=>{
                return a.name.localeCompare(b.name)
            }) : selectList;
        } catch (e) {
            console.log(e.toString());
            newSelectList = selectList;
        }
        return (
            <div style={{padding: '20px 0px 0px 10px'}}>{
                selectListLength > 0 ? <Scrollbars autoHide style={{height: height - 51 - 40 - 32}} key={uuid()}>
                        {
                            newSelectList && newSelectList.length && newSelectList.map(item => {
                                return (
                                    <div
                                        key={item.id}
                                        style={{
                                            display: item.hide ? 'none' : 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                        <div style={{width: 260}}>{item.name}（{item.deptName.join('，')}）</div>
                                        <Button type={"link"} onClick={() => {
                                            onRemove(item)
                                        }}>移除</Button>
                                    </div>
                                )
                            })
                        }   </Scrollbars> :
                    <div style={{position: "absolute", top: '50%', marginTop: '-100px', marginLeft: 50}}><Empty/></div>}
            </div>
        )
    };

    renderLeftTree = () => {
        const {column, height, onExpand, onCheck, expandedKeys, autoExpandParent,checkedKeys,onTreeSelect,color} = this.props;
        let treeData1 = this.formatTree(column,JSON.parse(JSON.stringify(this.props.treeData)),"");
        let treeData = this.setKey(treeData1);
        let empty = this.getEmpty(treeData);

        let treeNodes = <></>;
        if(empty){
            treeNodes = this.renderTreeNodes(treeData, 0);
            if(!treeNodes){
                empty = false;
            }
        }
        return (
            <div style={{padding: '20px 0px 0px 10px'}} id={'treeBox'} >
                <Scrollbars autoHide style={{height:height-51-30}}>
                    {empty ?<Tree
                            showIcon
                            defaultExpandParent={true}
                            defaultExpandAll={true}
                            // 展示复选框
                            checkable
                            // 展开的节点
                            expandedKeys={expandedKeys}
                            // 自动展开对应的父节点
                            autoExpandParent={autoExpandParent}
                            defaultExpandedKeys={['0']}
                            // 展开节点回调
                            onExpand={onExpand}
                            // 选中节点回调
                            onCheck={onCheck}
                            checkedKeys={checkedKeys}
                            selectable={false}
                        >
                            {treeNodes}
                        </Tree>
                        :<div style={{position: "relative",top:'50%',marginTop:'-100px'}}><Empty/></div> }
                <style>{
                    `
                    #treeBox .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected { background-color: #ffffff;}
                    #treeBox::-webkit-scrollbar { 
                            width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
                            height:0px;
                        }
                    #treeBox::-webkit-scrollbar-thumb {
                            border-radius: 10px;
                            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
                            background: rgba(0,0,0,0.2);
                        }
                    #treeBox::-webkit-scrollbar-track {
                            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.02);
                            border-radius: 0;
                            background: rgba(0,0,0,0.01);
                       }
                    #treeBox .ant-tree-checkbox-inner::after {
                        background-color: ${color};
                    }
                    `
                }</style>
                </Scrollbars>
            </div>

        )
    };


    getEmpty = (treeData) => {
        const {searchTreeText} = this.props;
        if(!(treeData && treeData.length)) return false;
        if(searchTreeText) {
            return this.getSearchEmpty(treeData, searchTreeText)
        } else {
            return true
        }
    };

    getSearchEmpty = (treeData, searchTreeText) => {
        return treeData.find(item => {
            if (item.name.indexOf(searchTreeText) > -1 && item.type=="person") {
                return true;
            } else if (item.children && item.children.length) {
                return this.getSearchEmpty(item.children, searchTreeText)
            } else {
                return false
            }
        });
    };

    renderTreeNodes(data,floor)  {
        const {nodeIcon, fileIcon} = this.props;
        let result = [];
        data && data.length && data.forEach(item => {
            let needSon = item.children || item.type === "dept";
            let showNode;
            try {
                showNode = this.showNode(item)
            } catch (e) {
                showNode = true
            }

            if (item.children) {
                let childTreeNodes = this.renderTreeNodes(item.children, floor + 1);

                // if (childTreeNodes) {
                    result.push(
                        <TreeNode type={item.type} style={{display: showNode ? 'list-item' : 'none'}}
                                  title={this.renderTitle(nodeIcon, item, floor)} key={item.key} dataRef={item}>
                            {childTreeNodes}
                        </TreeNode>
                    );
                    return;
                // }
            }
            if (showNode) {
                result.push(<TreeNode type={item.type} style={{display: item.isStepson ? 'none' : 'list-item'}}
                                      key={item.key} title={this.renderTitle(fileIcon, item, floor)} dataRef={item}/>);
            }
        });
        if (result.length > 0) {
            return result;
        }
        return null;
    };

    showNode = (item) => {
        const {searchTreeText} = this.props;
        // if(item.isStepson)return true;
        if(!searchTreeText) return true; //如果没有搜索字段则显示全部部门数据 && 如果当前数据是人则显示
        // 以下是有搜索的情况
        // if(!item || item.children.length<1) return false; // 如果当前部门没子代则不显示
        return this.haveSearchPerson([item], searchTreeText); // 当前部门是否含有符合搜索字段的人
        // return JSON.stringify(item).includes('"type":"person"') // 如果当前部门没后代不显示
    };

    haveSearchPerson = (tree, searchTreeText) => {
        return tree.some(item=>{
            if(item.type === "person") {
                return item.name.indexOf(searchTreeText)>-1
            } else if (item.children && item.children.length) {
                return this.haveSearchPerson(item.children, searchTreeText)
            } else {
                return false
            }
        })
    };

    renderTitle = (iconType, item,floor) => {
        const {nodeWidth, nodeTextWidth, nodeRightIcon, searchTreeText} = this.props;
        const index = searchTreeText.length > 0 ? item.name.indexOf(searchTreeText) : -1;
        let width1 = nodeWidth - floor*19;
        let width2 = nodeTextWidth - floor*19;
        return (
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", width: width1,}}>
                <div style={{display: "flex", alignItems: "center"}}>
                    {iconType?<Icon type={iconType}/>:null}
                    <Tooltip placement="top" title={item.title}>
                        <span style={{width:width2,
                            overflow: 'hidden',
                            marginLeft:'5px',
                            textOverflow: 'ellipsis', whiteSpace: 'nowrap',
                            color: index > -1 ? '#f50' : 'unset'
                        }}
                        >{item.title}</span>
                    </Tooltip>
                </div>
                {/*<div onClick={()=>{this.setCollect(item)}}>{item.collect ? <Icon type="star" theme="filled" style={{color:"#f0a738"}} /> : <Icon type={nodeRightIcon} />}</div>*/}
            </div>
        )
    };

    setKey = (data) => {
        if(!data || data.length<1) return data;
        if(data&&data.length){
            data.forEach((item,index)=>{
                if(item && item.child) {
                   this.setKey(item.child)
                }else{
                    if(item.key){
                        item.key =item.key.split('-');
                        if(item.key.length>2){
                            item.key =  item.key.slice(-2)
                        }
                        item.key= item.key.join("-")
                    }
                }

            })
        }
         return data

    };

    formatTree = (column, tree, fIds) => {
        if(!column || !tree || tree.length<1) return tree;
        return tree.map(item=>{
            let newNode = this.formatNode(column, item, fIds);
            if(newNode['children'] && newNode['children'].length) {
                let newfIds = fIds;
                if(newfIds) {
                    newfIds = newfIds + "-" + newNode.id
                } else {
                    newfIds = newNode.id
                }
                return {
                    ...newNode,
                    'children':this.formatTree(column, newNode['children'], newfIds)
                }
            } else {
                return newNode
            }
        })
    };

    formatNode = (column,node, fIds) => {
        for(let i in column) {
            if(i==='key') {
                let newfIds = fIds;
                if(newfIds) {
                    newfIds = newfIds + "-" + node[column[i]]
                } else {
                    newfIds = node[column[i]]
                }
                node[i] = newfIds
            } else {
                node[i] = node[column[i]]
            }
        }
        return node
    };

}